import NewComponentsMenu from "./NewComponentsMenu";

export default NewComponentsMenu;
